export { default } from "./ad.api";

export * from "./ad.api.types";
